/**
 * @generated SignedSource<<c360adea923cd163a8372f8bf889b04f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoomImageCredits_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemDisplayDimensions_item">;
  readonly " $fragmentType": "ViewInRoomImageCredits_item";
};
export type ViewInRoomImageCredits_item$key = {
  readonly " $data"?: ViewInRoomImageCredits_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImageCredits_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemDisplayDimensions_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7d9ca46f86232ad05fa79e20255d0374";

export default node;
